export type WebChannelDomainTypes = 'None' | 'FullDomain' | 'SubDomain';


export enum WebChannelDomainEnum {
  NONE = 'None',
  FULL_DOMAIN = 'FullDomain',
  SUB_DOMAIN = 'SubDomain',
}
